import '@cloudscape-design/global-styles/index.css';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/700.css';
import { applyTheme } from '@cloudscape-design/components/theming';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { PlatformConfigContext } from '@deloitte-us-consulting/gp-sdk';
import { AuthProvider } from './auth/AuthProvider';
import { PreferencesProvider } from './preferences/PreferencesProvider';
import { RbacProvider } from './rbac/RbacProvider';
import { router } from './router';
import { deloitteTheme } from './theme/deloitteTheme';

applyTheme({ theme: deloitteTheme });

// Platform API base URL, handed to remotes via the SDK so they can call the API /
// AI gateway without hardcoding it.
const API_URL = (import.meta.env.VITE_API_URL as string) ?? '';

// The shell owns one QueryClient for its own data. (Apps that mount as remotes bring
// their own QueryClient; the SDK separately owns an internal one for its hooks.)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PlatformConfigContext.Provider value={{ apiBaseUrl: API_URL }}>
      <AuthProvider>
        <PreferencesProvider>
          <QueryClientProvider client={queryClient}>
            <RbacProvider>
              <RouterProvider router={router} />
            </RbacProvider>
          </QueryClientProvider>
        </PreferencesProvider>
      </AuthProvider>
    </PlatformConfigContext.Provider>
  </StrictMode>,
);
